// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LongWriteActivityResultInfo
 */
export interface LongWriteActivityResultInfo {
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityResultInfo
   */
  activityId?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityResultInfo
   */
  activityTemplate?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityResultInfo
   */
  displayCategory?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityResultInfo
   */
  displayTopic?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityResultInfo
   */
  activityResultId?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityResultInfo
   */
  userTitle?: string | null
  /**
   *
   * @type {Date}
   * @memberof LongWriteActivityResultInfo
   */
  lastUpdatedDate?: Date
}

/**
 * Check if a given object implements the LongWriteActivityResultInfo interface.
 */
export function instanceOfLongWriteActivityResultInfo(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function LongWriteActivityResultInfoFromJSON(
  json: any,
): LongWriteActivityResultInfo {
  return LongWriteActivityResultInfoFromJSONTyped(json, false)
}

export function LongWriteActivityResultInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LongWriteActivityResultInfo {
  if (json === undefined || json === null) {
    return json
  }
  return {
    activityId: !exists(json, 'activityId') ? undefined : json['activityId'],
    activityTemplate: !exists(json, 'activityTemplate')
      ? undefined
      : json['activityTemplate'],
    displayCategory: !exists(json, 'displayCategory')
      ? undefined
      : json['displayCategory'],
    displayTopic: !exists(json, 'displayTopic')
      ? undefined
      : json['displayTopic'],
    activityResultId: !exists(json, 'activityResultId')
      ? undefined
      : json['activityResultId'],
    userTitle: !exists(json, 'userTitle') ? undefined : json['userTitle'],
    lastUpdatedDate: !exists(json, 'lastUpdatedDate')
      ? undefined
      : new Date(json['lastUpdatedDate']),
  }
}

export function LongWriteActivityResultInfoToJSON(
  value?: LongWriteActivityResultInfo | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    activityId: value.activityId,
    activityTemplate: value.activityTemplate,
    displayCategory: value.displayCategory,
    displayTopic: value.displayTopic,
    activityResultId: value.activityResultId,
    userTitle: value.userTitle,
    lastUpdatedDate:
      value.lastUpdatedDate === undefined
        ? undefined
        : value.lastUpdatedDate.toISOString(),
  }
}
